import { CloudFunctions } from '@/components/cloudFunctions'
import { useBrandingCodeStore } from '@/stores/brandingCode'
import createLogger from '@/utils/logger'
import type { NavigationGuardNext, RouteLocationNormalizedGeneric } from 'vue-router'

const logger = createLogger('router/guards/brandingCodeCapture.ts')

export async function brandingCodeCapture(
  to: RouteLocationNormalizedGeneric,
  _from: RouteLocationNormalizedGeneric,
  next: NavigationGuardNext,
) {
  const code = to.query.ref as string
  if (code) {
    try {
      const result = await CloudFunctions.Signup.validateBrandingCode({
        brandingCode: code,
      })
      if (result.valid) {
        const brandingCodeStore = useBrandingCodeStore()
        brandingCodeStore.saveBrandingCode(code)
      }
    } catch (error) {
      logger.error('Error validating branding code:', error)
    }
    next()
  } else {
    next()
  }
}
